export const apiEndpoints: { [key: string]: string } = {
  accounts: '/accounts',
  activitylogs: '/activitylogs',
  bankaccountrules: '/bankaccountrules',
  bankcards: '/bankcards',
  boprofiles: '/boprofiles',
  bousers: '/bousers',
  chartdatas: '/chartdatas',
  commissionsparams: '/commissionsparams',
  communicationpartner: '/communicationpartner',
  documents: '/documents',
  emails: '/emails',
  enrolment: '/enrolment',
  factures: '/factures',
  files: '/files',
  help: '/help',
  ibans: '/ibans',
  invitations: '/invitations',
  ipwhitelist: '/ipwhitelist',
  notificationparams: '/notificationparams',
  notifications: '/notifications',
  oauth2basics: '/oauth2basics',
  paymentforms: '/paymentforms',
  reports: '/reports',
  moneyInSummary: '/moneyInSummary',
  resetpasswordtokens: '/resetpasswordtokens',
  rollingreserve: '/rollingreserve',
  sddmandates: '/sddmandates',
  sessions: '/sessions',
  statistics: '/statistics',
  thresholds: '/thresholds',
  transactions: '/transactions',
  transactionsHistory: '/transactionsHistory',
  views: '/Views',
  twofa: '/2fa',
  ultimatebeneficialowners: '/ultimatebeneficialowners',
  virtualibans: '/virtualibans',
  wallets: '/wallets',
  merchantWallets: '/merchantWallets',
  savedCards: '/savedCards',
  savedCard: '/bankcards',
  branding: '/branding',
  pendingAccounts: '/PendingAccounts',
  approvalWorkflows: '/approvalWorkflows',
  partnerConfiguration: '/Configs',
  complianceReport: '/ComplianceReport'
};
